import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

// services

//components
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'stores/store';

function AccountStatusComponent() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const company = useSelector((state: RootState) => state.company);

	const navigateHandler = () => {
		if (company?.company_shareholder_status === 'Rejected' && company?.profile_status !== 'FieldUpdateRequest')
			navigate('/dashboard/shareholders-registry');

		if (company?.company_shareholder_status !== 'Rejected' && company?.profile_status === 'FieldUpdateRequest')
			navigate('/dashboard/company-documents');

		if (company?.company_shareholder_status === 'Rejected' && company?.profile_status === 'FieldUpdateRequest') navigate('/dashboard');

		if (company?.profile_status === 'Active' && company?.company_shareholder_status === 'Approved') navigate('/dashboard');
	};

	return (
		<>
			<Button color="danger" variant="filled" size="large" className="text-middle" onClick={navigateHandler}>
				<p className="mb-0 fw-medium">
					{company?.profile_status === 'Active' && company?.company_shareholder_status === 'Approved'
						? t('COMMON.WAITING_ACTIVATION')
						: company?.company_shareholder_status === 'Rejected' && company?.profile_status === 'FieldUpdateRequest'
							? t('COMMON.AMENDMENTS')
							: company?.company_shareholder_status === 'Rejected' && company?.profile_status !== 'FieldUpdateRequest'
								? t('COMMON.REGISTRY_AMENDMENTS')
								: company?.company_shareholder_status !== 'Rejected' && company?.profile_status === 'FieldUpdateRequest'
									? t('COMMON.DOCUMENT_AMENDMENTS')
									: company?.profile_status === 'UnderReview' && company?.company_shareholder_status === 'UnderReview' && company.has_documents
										? t('COMMON.UNDER_REVIEW')
										: company?.profile_status === 'GeneralSuspended'
											? t('COMMON.COMPANY_GENERAL_SUSPENDED')
											: t('COMMON.UPLOAD_REQUIREMENTS')}
				</p>
			</Button>
		</>
	);
}

export default AccountStatusComponent;
